import {LAYOUT} from '@dofleini/auth-layout';
// import LoginImageSide  from '../assets/images/login-back.png';

export const authentication = {
  // image: LoginImageSide,
  // background: '#41A636',
  formBackground: '#ffffff',
  layout: LAYOUT.CENTER_BOX,
  path: '/ms-auth',
  showInviteLInk: false,
  showUserName: true,
  showAddress: false,
  //in milliseconds
  tokenExpirationTime: 2 * 60 * 60 * 1000,
  activeOnboarding: true,
  hideOnBoardingFb: true,
  hideOnBoardingGoogle: true,
};
